import { render, staticRenderFns } from "./SettingCard.vue?vue&type=template&id=4b1889c8&scoped=true"
import script from "./SettingCard.vue?vue&type=script&lang=js"
export * from "./SettingCard.vue?vue&type=script&lang=js"
import style0 from "./SettingCard.vue?vue&type=style&index=0&id=4b1889c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1889c8",
  null
  
)

export default component.exports